export const DEVICE_LEVELS = [
  { level: 1, label: 'Stationary Kiosk on BIT Trusted Network', color: '#6BAF23', bgColor: '#d3e9bb' },
  { level: 2, label: 'Floating Kiosk on BIT Trusted Network', color: '#0C682A', bgColor: '#8BE7A9' },
  { level: 3, label: 'Verifed Personal Devices on Public Network', color: '#02381B', bgColor: '#81B79A' },
  { level: 4, label: 'Unverifed Personal Devices on Public Network', color: '#191617', bgColor: '#989596' },
];
